// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_box__tx2d8 {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}
.style_box2__P2\\+fw {
  display: flex;
  align-items: center;
  width: 20rem !important;
}


.style_loaderContainer__NpNEV {
  display: flex;
  justify-content: center;
  align-items: center;
}
.style_navBar__aG2Bb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.style_oneLine__QH2ic {
  display: flex;
  align-items: center;
}
.style_heading__XXvLG{
  margin-right: 10px;
  font-weight: 600;
}

.style_btn__HP3st {
  background-color: #0a6bff;
  border-radius: 50px;
  border: 0;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  min-height: 40px;
  min-width: 120px;
  transition: all .2s cubic-bezier(.22, .61, .36, 1);
}


`, "",{"version":3,"sources":["webpack://./src/commonComponents/filterBox/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kDAAkD;AACpD","sourcesContent":[".box {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n.box2 {\n  display: flex;\n  align-items: center;\n  width: 20rem !important;\n}\n\n\n.loaderContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.navBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.oneLine {\n  display: flex;\n  align-items: center;\n}\n.heading{\n  margin-right: 10px;\n  font-weight: 600;\n}\n\n.btn {\n  background-color: #0a6bff;\n  border-radius: 50px;\n  border: 0;\n  box-sizing: border-box;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  min-height: 40px;\n  min-width: 120px;\n  transition: all .2s cubic-bezier(.22, .61, .36, 1);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `style_box__tx2d8`,
	"box2": `style_box2__P2+fw`,
	"loaderContainer": `style_loaderContainer__NpNEV`,
	"navBar": `style_navBar__aG2Bb`,
	"oneLine": `style_oneLine__QH2ic`,
	"heading": `style_heading__XXvLG`,
	"btn": `style_btn__HP3st`
};
export default ___CSS_LOADER_EXPORT___;
